import React, { useState, useEffect } from "react";
import { X, ZoomIn, ZoomOut, Maximize2 } from "lucide-react";

export default function ImageLightbox({ src, onClose }) {
  const [zoom, setZoom] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const onMouseDown = (e) => {
    if (zoom <= 1) return;
    setDragging(true);
    setStart({ x: e.clientX - pos.x, y: e.clientY - pos.y });
  };
  const onMouseMove = (e) => {
    if (!dragging) return;
    setPos({ x: e.clientX - start.x, y: e.clientY - start.y });
  };
  const onMouseUp = () => setDragging(false);

  return (
    <div className="fixed inset-0 z-[80] bg-black/95 flex flex-col animate-fadeIn" data-testid="image-lightbox"
      onMouseMove={onMouseMove} onMouseUp={onMouseUp}>
      <div className="flex items-center justify-between p-3 border-b border-white/20">
        <div className="font-mono text-[10px] uppercase tracking-widest text-white/70">PRATINJAU GAMBAR</div>
        <button onClick={onClose} data-testid="lightbox-close"
          className="w-10 h-10 border border-white text-white hover:bg-white hover:text-black transition-colors">
          <X size={16} className="mx-auto" strokeWidth={2.5} />
        </button>
      </div>
      <div className="flex-1 overflow-hidden flex items-center justify-center select-none"
        onMouseDown={onMouseDown}
        style={{ cursor: zoom > 1 ? (dragging ? "grabbing" : "grab") : "default" }}>
        <img src={src} alt=""
          draggable={false}
          style={{
            transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
            transition: dragging ? "none" : "transform 160ms ease",
            maxWidth: "100vw",
            maxHeight: "85vh",
          }}
        />
      </div>
      <div className="border-t border-white/20 p-3 flex items-center justify-center gap-4 bg-black/70">
        <button onClick={() => { setZoom(Math.max(0.5, zoom - 0.25)); setPos({ x: 0, y: 0 }); }} data-testid="zoom-out"
          className="w-10 h-10 border border-white text-white hover:bg-white hover:text-black">
          <ZoomOut size={16} className="mx-auto" strokeWidth={2.5} />
        </button>
        <input type="range" min="0.5" max="4" step="0.1" value={zoom}
          onChange={(e) => setZoom(parseFloat(e.target.value))}
          data-testid="zoom-slider"
          className="w-64 accent-white" />
        <span className="font-mono text-xs text-white tabular-nums w-12 text-center">{Math.round(zoom * 100)}%</span>
        <button onClick={() => { setZoom(Math.min(4, zoom + 0.25)); }} data-testid="zoom-in"
          className="w-10 h-10 border border-white text-white hover:bg-white hover:text-black">
          <ZoomIn size={16} className="mx-auto" strokeWidth={2.5} />
        </button>
        <button onClick={() => { setZoom(1); setPos({ x: 0, y: 0 }); }} data-testid="zoom-reset"
          className="w-10 h-10 border border-white text-white hover:bg-white hover:text-black">
          <Maximize2 size={16} className="mx-auto" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
